<template>
  <div>
    <el-form inline :model="searchForm" :loading="loading">
      <el-form-item label="手机号">
        <el-input placeholder="请输入手机号" v-model="searchForm.phone">
          <div slot="suffix" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" />
        </el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="searchForm.names" placeholder="请输入姓名">
          <div slot="suffix" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" />
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
        <el-button @click="reset" icon="el-icon-refresh-right">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list"
              ref="tableView"
              :header-cell-style="{background:'#eee',color:'black'}"
              max-height="400"
              style="margin-top: 1rem"
    >
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       :fixed="item.flex"
                       v-if="item.type !== 3 && item.type !== 4 && item.type !== 5"
                       :type="item.typeText"
      >
      </el-table-column>
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       fixed="right"
                       v-if="item.type === 3"
                       :type="item.typeText"
      >
        <template slot-scope="scope">
          <el-button v-for="(actionItem, actionIndex) in item.actions" :key="'btn_' + actionIndex" size="mini" :type="actionItem.btnType" @click="btnAction(actionItem, scope.row)">
            {{actionItem.title}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {operationByPath, queryPermissionGroupMember} from './employeeApi'

export default {
  name: 'permissionGroupMember',
  data () {
    return {
      searchForm: {
        phone: '',
        name: ''
      },
      loading: false,
      list: [],
      listKeyMap: []
    }
  },
  props: {
    groupData: null
  },
  watch: {
    groupData (d) {
      this.searchForm = {
        name: '',
        phone: ''
      }
      this.search()
      this.list = []
      this.listKeyMap = []
    }
  },
  created () {
    if (this.groupData) {
      this.search()
    }
  },
  methods: {
    search () {
      this.loading = true
      const data = {}
      data.groupId = this.groupData.groupId
      queryPermissionGroupMember(data).then(rsp => {
        this.loading = false
        const {code, message, result} = rsp
        if (code === 0) {
          const { employees, values } = result
          this.list = employees
          this.listKeyMap = values
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    reset () {
      this.searchForm.name = ''
      this.searchForm.phone = ''
    },
    replaceText (text, item, encode) {
      const keys = Object.keys(item)
      for (let i = 0; i < keys.length; i++) {
        const tempKey = keys[i]
        const matchText = '{' + tempKey + '}'
        const index = text.indexOf(matchText)
        if (index >= 0) {
          if (encode === true) {
            text = text.replace(matchText, encodeURIComponent(item[tempKey]))
          } else {
            text = text.replace(matchText, item[tempKey])
          }
        }
      }
      return text
    },
    btnAction (action, item) {
      const { type } = action
      if (type === 1) {
        const deleteAction = () => {
          let { actionLink } = action
          actionLink = this.replaceText(actionLink, item, true)
          operationByPath(actionLink).then(rsp => {
            const {code, message} = rsp
            if (code === 0) {
              this.search()
              this.$message.success('操作成功')
            } else {
              this.$message.error(message)
            }
          })
        }

        let { alertMsg } = action
        alertMsg = this.replaceText(alertMsg, item, false)
        this.$confirm(alertMsg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(deleteAction).catch(null)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/employee/permissionGroupMember.vue